import "./Badge.css";
import type { BadgeProps } from "./Badge.types";

export function Badge({ tone = "neutral", children, className = "", ...props }: BadgeProps) {
  return (
    <span className={`rg-badge rg-badge--${tone} ${className}`.trim()} {...props}>
      {children}
    </span>
  );
}
